import { render, staticRenderFns } from "./BaseFormLabel.vue?vue&type=template&id=088ecb46&scoped=true&"
import script from "./BaseFormLabel.vue?vue&type=script&lang=ts&"
export * from "./BaseFormLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088ecb46",
  null
  
)

export default component.exports